<template>
    <div>
        <div
            class="fixed z-501 inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full"
            id="my-modal"
        />
        <div class="absolute z-501 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 m-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div
                class="absolute top-4 right-4 cursor-pointer z-50"
                @click="$emit('close')"
            >
                <svg class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
            </div>
            <div class="text-center">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Claim field</h3>
                <div class="mb-3 px-7 py-3">
                    <p class="text-sm text-gray-500">
                        You agree that you will not submit a field boundary to the Services unless you are the legal owner of the field or authorized to act on the field owner’s behalf.
                    </p>
                </div>

                <form class="text-left">
                    <div class="flex flex-wrap -mx-3">
                        <div class="w-full px-3 mb-6">
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="field-name">
                                Name
                            </label>
                            <div class="relative">
                                <input
                                    v-model="claimData.name"
                                    :class="{'border-red-500': errorMessages.name || nameMaxLength === claimData.name.length}"
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 pr-10 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="field-name"
                                    type="text"
                                    placeholder="Enter field name"
                                >
                                <!-- Character counter -->
                                <!-- <div class="absolute top-1 right-1 bottom-1 flex items-center justify-center flex-shrink-0 w-8 text-center text-gray-700 bg-gray-300 rounded cursor-default" v-text="(nameMaxLength - claimData.name.length)" /> -->
                            </div>
                            <p v-if="nameMaxLength === claimData.name.length" class="mt-2 text-red-500 text-xs italic">{{ nameMaxLength }} characters is limit for field name!</p>
                            <p v-if="errorMessages.name" class="mt-2 text-red-500 text-xs italic">Please enter field name!</p>
                        </div>
                        <div class="w-full px-3 mb-6">
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="field-farm">
                                Farm
                            </label>
                            <div class="relative">
                                <select
                                    v-model="claimData.farm"
                                    :class="{'border-red-500': errorMessages.farm}"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="field-farm"
                                >
                                    <template v-for="farm in myFarms">
                                        <option
                                            :key="farm.id"
                                            :value="farm.id"
                                        >
                                            {{ farm.name }}
                                        </option>
                                    </template>
                                </select>
                            </div>
                            <p v-if="errorMessages.farm" class="mt-2 text-red-500 text-xs italic">Please select farm!</p>
                        </div>
                        <div class="w-full px-3 mb-6">
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="field-crop">
                                Crop
                            </label>
                            <div class="relative">
                                <select
                                    v-model="claimData.crop"
                                    :class="{'border-red-500': errorMessages.crop}"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="field-crop"
                                >
                                    <option value=""></option>
                                    <template v-for="crop in myCrops">
                                        <option
                                            :key="crop.id"
                                            :value="crop.id"
                                        >
                                            {{ crop.name }}
                                        </option>
                                    </template>
                                </select>
                            </div>
                            <p v-if="errorMessages.crop" class="mt-2 text-red-500 text-xs italic">Please select crop!</p>
                        </div>
                        <div v-if="claimData.crop" class="w-full px-3 mb-6">
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="field-crop-trait">
                                Crop Trait
                            </label>
                            <div class="relative">
                                <select
                                    v-model="claimData.crop_trait"
                                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="field-crop"
                                >
                                    <option value=""></option>
                                    <template v-for="trait in selectedCropTrait(claimData.crop)">
                                        <option
                                            :key="trait.id"
                                            :value="trait.id"
                                        >
                                            {{ trait.name }}
                                        </option>
                                    </template>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>

                <button
                    class="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
                    @click="submitForm()"
                >
                    Claim
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import isEmpty from 'lodash/isEmpty';

export default {
    name: 'MapClaimModal',

    props: {
        field: {}
    },

    data: () => ({
        claimData: {
            name: '',
            farm: null,
            crop: null,
            crop_trait: null,
        },
        nameMaxLength: 30,
        errorMessages: {
            name: false,
            farm: false,
        },
        triedToSubmit: false
    }),

    computed: {
        ...mapState('leaflet', ['activeFarmId']),
        ...mapState('retailer', ['activeAccountFarms']),
        ...mapState('user', ['myFarms', 'myCrops', 'myCropTraits'])
    },

    watch: {
        // Watch changes in input field because of
        claimData: {
            handler(newValue) {
                if (!this.triedToSubmit) return;
                this.errorMessages.name = !newValue.name;
                this.errorMessages.farm = !newValue.farm;
            },
            deep: true
        }
    },

    created() {
        if (this.activeFarmId) this.claimData.farm = this.activeFarmId;
    },

    methods: {
        submitForm() {
            this.triedToSubmit = true;

            if (!this.claimData.name && !this.claimData.farm) {
                this.errorMessages.name = !this.claimData.name;
                this.errorMessages.farm = !this.claimData.farm;
                return;
            }

            this.$emit('submit', {
                field: this.field,
                claimData: this.claimData
            });
        },

        selectedCropTrait(cropId) {
            const selectedCrop = this.myCrops.find(crop => crop.id === cropId);

            return !isEmpty(selectedCrop)
                ? this.myCropTraits[selectedCrop.name]
                : null;
        }
    }
}
</script>